module.exports = __webpack_public_path__ + "img/xcx.16ec96d8.png";